export interface Page {
  prev?: string;
  next?: string;
  limit: number;
  count: boolean;
}

export const MAX_LIMIT = 5000;

export const firstPage = (): Page => ({
  limit: 50,
  count: false,
});

export const firstPageWithCount = (): Page => ({
  ...firstPage(),
  count: true,
});

export const largePage = (): Page => ({
  limit: MAX_LIMIT,
  count: false,
});

export const pageWithOneItem = (): Page => ({
  limit: 1,
  count: false,
});

export const pageWithTenItemsAndCount = (): Page => ({
  limit: 10,
  count: true,
});

/**
 * Fetching 100 items is a good compromise between performance and data freshness.
 *
 * To be used when you don't have pagination, and you want to fetch almost all items, if you know that there are not too
 * many. Else, consider using firstPageWithCount().
 */
export const smallPage = (): Page => ({
  limit: 100,
  count: false,
});

export const Page = {
  maxLimit: MAX_LIMIT,
};
